import React from 'react'
import SkeletonBlock from './SkeletonBlock'
import SkeletonText from './SkeletonText'
import SkeletonCard from './SkeletonCard'

/**
 * Groups page placeholder: top button row + a vertical stack (mobile)
 * or 2-col grid (desktop) of group-card skeletons.
 */
function GroupsSkeleton() {
  return (
    <div className="min-h-screen bg-app">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        {/* Page button row */}
        <div className="flex flex-row items-center sm:justify-end gap-3">
          <SkeletonBlock className="flex-1 sm:flex-none sm:w-36 h-11 rounded-lg" />
          <SkeletonBlock className="flex-1 sm:flex-none sm:w-36 h-11 rounded-lg" />
        </div>
        {/* Group cards */}
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {[0, 1].map((i) => (
            <SkeletonCard key={i}>
              <SkeletonText className="w-2/3 h-4 mb-3" />
              <div className="flex gap-2 mb-4">
                <SkeletonBlock className="w-12 h-5 rounded" />
                <SkeletonBlock className="w-16 h-5 rounded" />
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-4 border-t border-border-subtle">
                {[0, 1, 2].map((j) => (
                  <div key={j} className="flex items-center">
                    <SkeletonBlock className="w-8 h-8 rounded-lg mr-3" />
                    <div className="flex-1">
                      <SkeletonText className="w-8 h-3 mb-1" />
                      <SkeletonText className="w-16 h-2.5" />
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex gap-3 pt-4">
                <SkeletonBlock className="flex-1 h-11 rounded-lg" />
                <SkeletonBlock className="flex-1 h-11 rounded-lg" />
              </div>
            </SkeletonCard>
          ))}
        </div>
      </div>
    </div>
  )
}

export default GroupsSkeleton
